module.exports = __webpack_public_path__ + "static/media/list-ul.97954a53.svg";